import { anchorPointComponents } from './anchor-point.js';
import { anchorableShapeComponents } from './anchorable-shape.js';
import { bendablePlateComponents } from './bendable-plate.js';
import { cornerBoltHolesComponents } from './corner-bolt-holes.js';
import { cornerCountersinkHolesComponents } from './corner-countersink-holes.js';
import { customBendComponents } from './custom-bend.js';
import { holeComponents } from './hole.js';
import { kickPlateBoltHolesComponents } from './kick-plate-bolt-holes.js';
import { kickPlateBulkOrderItemComponents } from './kick-plate-bulk-order-item.js';
import { kickPlateCountersinkHolesComponents } from './kick-plate-countersink-holes.js';
import { kickPlateFixingHolesComponents } from './kick-plate-fixing-holes.js';
import { kickPlateComponents } from './kick-plate.js';
import { plateComponents } from './plate.js';
import { rectangularPlateComponents } from './rectangular-plate.js';
import { rootEntityComponents } from './root-entity.js';
import { squarePlateComponents } from './square-plate.js';
import { strikePlateComponents } from './strike-plate.js';
export const generatedComponents = [
    ...holeComponents,
    ...kickPlateBulkOrderItemComponents,
    ...plateComponents,
    ...anchorableShapeComponents,
    ...strikePlateComponents,
    ...kickPlateComponents,
    ...anchorPointComponents,
    ...rootEntityComponents,
    ...bendablePlateComponents,
    ...customBendComponents,
    ...cornerCountersinkHolesComponents,
    ...cornerBoltHolesComponents,
    ...kickPlateBoltHolesComponents,
    ...kickPlateCountersinkHolesComponents,
    ...kickPlateFixingHolesComponents,
    ...squarePlateComponents,
    ...rectangularPlateComponents
];

//# sourceMappingURL=index.js.map